import React from 'react';
import { LinkButton } from '@adsk/alloy-button';
import { useLocale } from '@adsk/alloy-helpers';

var DefaultLoadMore = function DefaultLoadMore(_ref) {
  var inViewRef = _ref.inViewRef,
      onLoad = _ref.onLoad;

  var _useLocale = useLocale(function (_ref2) {
    var locale = _ref2.locale;
    return require("../i18n/".concat(locale, ".json"));
  }),
      T = _useLocale.T;

  return /*#__PURE__*/React.createElement(LinkButton, {
    ref: inViewRef,
    "data-testid": "loadMore",
    onClick: onLoad,
    size: LinkButton.SIZES.SMALL
  }, T.translate('LOAD_MORE'));
};

export default DefaultLoadMore;
//# sourceMappingURL=DefaultLoadMore.js.map